import type { JSX } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from '@heroicons/react/24/outline';

import type { PatternDomain } from '~/types';

import { formatDomainLabel, formatPatternTitle } from '../utils';

interface PatternBreadcrumbProps {
  domain: PatternDomain;
  patternId: string;
}

export function PatternBreadcrumb({ domain, patternId }: PatternBreadcrumbProps): JSX.Element {
  return (
    <nav className="flex items-center gap-1 text-sm text-muted mb-4" aria-label="Breadcrumb">
      <Link to="/patterns" className="hover:text-foreground transition-colors">
        Design Patterns
      </Link>
      <ChevronRightIcon className="h-3 w-3" />
      <Link to={`/patterns?domain=${domain}`} className="hover:text-foreground transition-colors">
        {formatDomainLabel(domain)}
      </Link>
      <ChevronRightIcon className="h-3 w-3" />
      <span className="text-foreground font-medium">{formatPatternTitle(patternId)}</span>
    </nav>
  );
}
